import { Components, Theme } from '@mui/material';

export const createButtonStyles = (theme: Theme): Components['MuiButton'] => ({
  styleOverrides: {
    root: {
      borderRadius: theme.shape.borderRadius,
      boxShadow: 'none',
      textTransform: 'none',
      fontWeight: 500,
      '&:hover': {
        boxShadow: `0 2px 8px ${theme.palette.primary.main}30`,
      },
    },
    contained: {
      '&.MuiButton-containedPrimary': {
        backgroundImage: `linear-gradient(to bottom right, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
      },
      '&.MuiButton-containedSecondary': {
        backgroundImage: `linear-gradient(to bottom right, ${theme.palette.secondary.main}, ${theme.palette.secondary.dark})`,
      },
    },
    outlined: {
      borderWidth: 2,
    },
  },
});

export const createRusticButtonStyles = (theme: Theme): Components['MuiButton'] => ({
  styleOverrides: {
    root: {
      borderRadius: 8,
      boxShadow: 'none',
      textTransform: 'none',
      fontWeight: 500,
      '&:hover': {
        boxShadow: '0 2px 8px rgba(191, 106, 45, 0.3)',
      },
    },
    contained: {
      '&.MuiButton-containedPrimary': {
        backgroundImage: 'linear-gradient(to bottom right, #bf6a2d, #8c4a1a)',
      },
      '&.MuiButton-containedSecondary': {
        backgroundImage: 'linear-gradient(to bottom right, #a77f41, #755523)',
      },
    },
    outlined: {
      borderWidth: 2,
    },
  },
}); 